import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './ThemeContext.ts';

/** 테마 컨텍스트 접근 훅. ThemeProvider 외부에서 호출 시 명확한 에러. */
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme 는 <ThemeProvider> 안에서만 사용할 수 있습니다.');
  }
  return ctx;
}
